import firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";
import "firebase/firestore";

var config = {
  apiKey: "AIzaSyAXHISxYjpjICb_qAyr3sa23MOQeVplHwU",
  authDomain: "uelstudios-freeway.firebaseapp.com",
  databaseURL: "https://uelstudios-freeway.firebaseio.com",
  projectId: "uelstudios-freeway",
  storageBucket: "uelstudios-freeway.appspot.com",
  messagingSenderId: "509129046304"
};

if (!firebase.apps.length) firebase.initializeApp(config);

const auth = firebase.auth();
const storage = firebase.storage();

const firestore = firebase.firestore();
firestore.settings({ timestampsInSnapshots: true });

export { auth, storage, firestore };



// WEBPACK FOOTER //
// ./src/firebase/firebase.js